// extracted by mini-css-extract-plugin
export default {"firstSection":"StartSectionLayout_firstSection__BlQe+","container":"StartSectionLayout_container__Z2BcY"};